import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import GuestGuard from 'utils/route-guard/GuestGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import Maps from 'views/map';
import DTC from 'views/dtc';
import BDR_TABLE from 'views/bdr-table';
import BDR_CHART from 'views/bdr-chart';
import LogsTable from 'views/device-logs/table';
import LogsChart from 'views/device-logs/charts';
import AddCustomer from 'views/upload-file';
import UploadFile from 'views/upload-file';
import ConfigChecker from 'views/config-checker';
import DM from 'views/dm';

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));
const Users = Loadable(lazy(() => import('views/users')));
const Variables = Loadable(lazy(() => import('views/variables')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <SamplePage />
        },
        {
            path: '/bdr-table',
            element: <BDR_TABLE />
        },
        {
            path: '/bdr-chart',
            // element: <BDR_CHART />
            element: <SamplePage />
        },
        {
            path: '/users',
            element: <Users />
        },
        {
            path: 'charts',
            element: <SamplePage />
        },
        {
            path: 'variables',
            element: <Variables />
        },
        {
            path: 'maps',
            element: <Maps />
        },
        {
            path: 'logs-charts',
            element: <LogsChart />
        },
        {
            path: 'logs-table',
            element: <LogsTable />
        },
        {
            path: 'dtc',
            element: <DTC />
        },
        {
            path: 'upload-file',
            element: <UploadFile />
        },
        {
            path: 'config-checker',
            element: <ConfigChecker />
        },
        {
            path: 'dm',
            element: <DM />
        }
    ]
};

export default MainRoutes;
